import { render, staticRenderFns } from "./_pagination2.vue?vue&type=template&id=a660f4ae"
import script from "./_pagination2.vue?vue&type=script&lang=js"
export * from "./_pagination2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports